var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('TodoHeader'),_c('Todos',{attrs:{"todos":_vm.todos}}),_c('TodoFooter',{attrs:{"todos":_vm.todos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }